<template>

  <div class="content">
    <div class="container" style="padding-left: 10px; overflow-x: hidden">
      <div class="row">

        <div class="col-md-12 px-0">
          <top-navbar :title="restaurantName"></top-navbar>
          <div class="row">
            <div class="col-md-2 col-lg-2 content_sidebar">
              <ul>
                <li @click="() => toggleDiv('isContent', 1)" :class="{ activeElement : active_el == 1 }" class="list-group-item">
                  Content
                </li>
                <li @click="() => toggleDiv('isImage', 2)" :class="{ activeElement : active_el == 2 }" class="list-group-item">
                  Image
                </li>
                <li @click="() => toggleDiv('isGallery', 3)" :class="{ activeElement : active_el == 3 }" class="list-group-item">
                  Gallery
                </li>
                <li @click="() => toggleDiv('isColor', 4)" :class="{ activeElement : active_el == 4 }" class="list-group-item">
                  Color
                </li>
                <li @click="openPaymentPasswordModal" :class="{ activeElement : active_el == 5 }" class="list-group-item">
                  Payment
                </li>
                <li @click="() => toggleDiv('isMenu', 6)" :class="{ activeElement : active_el == 6 }" class="list-group-item">
                  Menu PDF
                </li>
                <li @click="() => toggleDiv('isSocial', 7)" :class="{ activeElement : active_el == 7 }" class="list-group-item">
                  Social Media
                </li>
                <li @click="() => toggleDiv('isTimeSlot', 8)" :class="{ activeElement : active_el == 8 }" class="list-group-item">
                  Time
                </li>
                <li @click="() => toggleDiv('isBookingSettings', 9)" :class="{ activeElement : active_el == 9 }" class="list-group-item">
                  Booking
                </li>
              </ul>
            </div>
            <div class="col-md-10 col-lg-10 pl-1">
              <div style="background-color: #FFFFFF; height: 95vh; overflow-y: scroll; overflow-x: hidden; margin-bottom: 0rem;">

                <contents v-if="sidebarContentVisibility.isContent"
                  :webConfig="webData"
                  :requestHeader="requestHeader"
                ></contents>

                <all-images v-if="sidebarContentVisibility.isImage"
                  :icon="webData.favIcon"
                  :favIconPublicId="webData.favIconPublicId"
                  :logo="webData.logo"
                  :logoPublicId="webData.logoPublicId"
                  :bgImage="webData.backgroundImage"
                  :backgroundImagePublicId="webData.backgroundImagePublicId"
                  :headOneImgs="headerOneImages"
                  :headTwoImgs="headerTwoImages"
                  :headThreeImgs="headerThreeImages"
                  :requestHeader="requestHeader"
                ></all-images>

                <gallery v-if="sidebarContentVisibility.isGallery"
                  :webConfig="webData"
                  :requestHeader="requestHeader"
                ></gallery>

                <colors v-if="sidebarContentVisibility.isColor"
                  :webConfig="webData"
                  :requestHeader="requestHeader"
                ></colors>

                <payment v-if="sidebarContentVisibility.isPayment"
                  :webConfig="webData"
                  :requestHeader="requestHeader"
                ></payment>

                <menu-PDF v-if="sidebarContentVisibility.isMenu"
                  :menu="webData.menuPdf"
                  :menuPdfPublicId="webData.menuPdfPublicId"
                  :requestHeader="requestHeader"
                ></menu-PDF>

                <social-media v-if="sidebarContentVisibility.isSocial"
                  :webConfig="webData"
                  :requestHeader="requestHeader"
                ></social-media>

                <time-slot v-if="sidebarContentVisibility.isTimeSlot"
                  :requestHeader="requestHeader"
                ></time-slot>

                <booking-settings v-if="sidebarContentVisibility.isBookingSettings"
                  :requestHeader="requestHeader"
                ></booking-settings>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="modal-vue">
      <!-- overlay -->
      <div class="overlay" v-if="showPaymentPasswordModal" @click="closePaymentPasswordModal"></div>

      <!-- modal -->
      <div class="modal-own" v-if="showPaymentPasswordModal">
        <div class="modal-title">
          <h2 class="d-inline" style="color: rgb(254, 117, 15); margin: unset">Confirm Password</h2>
          <i class="fa fa-times float-right mr-3" @click="closePaymentPasswordModal" style="cursor: pointer; color: #fe750f; font-size: 2rem;"></i>
        </div>
        <div class="modal-body">
          <form @submit.prevent="confirmPasswordBeforePayment">
            <div class="form-group" style="margin: 2rem 0">
              <label style="color: red" for="confPassword" v-if="passMisMatch">Password doesn't match </label>
              <input type="password" class="form-control" id="confPassword" v-model="confPassword" placeholder="Password">
            </div>
            <button type="submit" class="btn submitBtn">Confirm</button>&nbsp;
            <img v-if="checkPasswordLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import TopNavbar from '../../layout/TopNavbar'
import axios from 'axios'
import logout from './../../mixins/logoutMixins.js'
import { mapMutations } from 'vuex'

export default {
  components: {
    TopNavbar,
    Contents: () => import('./v1/Contents'),
    AllImages: () => import('./v1/AllImages'),
    Gallery: () => import('./v1/Gallery'),
    Colors: () => import('./v1/Colors'),
    Payment: () => import('./v1/Payment'),
    MenuPDF: () => import('./v1/MenuPDF'),
    SocialMedia: () => import('./v1/SocialMedia'),
    TimeSlot: () => import('./v1/TimeSlot'),
    BookingSettings: () => import('./v1/BookingSettings')
  },
  data () {
    return {
      sidebarContentVisibility: {
        isContent: false,
        isImage: false,
        isGallery: false,
        isColor: false,
        isPayment: false,
        isMenu: false,
        isSocial: false,
        isTimeSlot: false,
        isBookingSettings: false,
      },
      active_el: 1,
      headerOneImages: [],
      headerTwoImages: [],
      headerThreeImages: [],
      requestHeader: null,
      jwtToken: '',
      webData: '',
      restaurantName: localStorage.getItem('restaurantName'),
      showPaymentPasswordModal: false,
      confPassword: '',
      checkPasswordLoading: false,
      passMisMatch: false,
    }
  },
  mounted () {
    this.jwtToken = this.$cookies.get('token') || null
    this.requestHeader = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.jwtToken}`,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": true,
      "Access-Control-Allow-Headers": "*",
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }

    if(this.$store.state.restaurantWebConfig) {
      this.webData = this.$store.state.restaurantWebConfig
      // initially show content
      this.sidebarContentVisibility.isContent = true

      if (typeof this.webData.headerOneImages != 'undefined'){
        for (var i=0; i<this.webData.headerOneImages.length; i++){
          this.headerOneImages.push({'src': this.webData.headerOneImages[i].url, 'publicId': this.webData.headerOneImages[i].publicId})
        }
      }
      if (typeof this.webData.headerTwoImages != 'undefined') {
        for (var j=0; j<this.webData.headerTwoImages.length; j++){
          this.headerTwoImages.push({'src': this.webData.headerTwoImages[j].url, 'publicId': this.webData.headerTwoImages[j].publicId})
        }
      }
      if (typeof this.webData.headerThreeImages != 'undefined') {
        for (var k=0; k<this.webData.headerThreeImages.length; k++){
          this.headerThreeImages.push({'src': this.webData.headerThreeImages[k].url, 'publicId': this.webData.headerThreeImages[k].publicId})
        }
      }
    } else {
      this.webConfig()
    }
  },
  methods: {
    ...mapMutations(['setRestaurantWebConfig']),

    webConfig(){
      let url = process.env.VUE_APP_API_URL+'/api/webConfig?restaurantId='+localStorage.getItem('restaurantId')
      axios
        .get(url,
          {
            headers: {
              Authorization: `Bearer ${this.jwtToken}`,
            }
          })
        .then((result) => {
          if (result.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                  this.$router.push({ path: '/login' })
              }
          }
          this.setRestaurantWebConfig(result.data)
          this.webData = result.data
          // initially show content
          this.sidebarContentVisibility.isContent = true
          if(localStorage.getItem('active_sidebar_el') != null){
            let active_el = JSON.parse(localStorage.getItem('active_sidebar_el'))
            // payment needs password verification, so never restore it automatically
            if (active_el.param != 'isPayment') {
              this.toggleDiv(active_el.param, active_el.el_no)
            }
          }
          const data = result.data
          if (typeof data.headerOneImages != 'undefined'){
            for (var i=0; i<data.headerOneImages.length; i++){
              this.headerOneImages.push({'src': data.headerOneImages[i].url, 'publicId': data.headerOneImages[i].publicId})
            }
          }
          if (typeof data.headerTwoImages != 'undefined') {
            for (var j=0; j<data.headerTwoImages.length; j++){
              this.headerTwoImages.push({'src': data.headerTwoImages[j].url, 'publicId': data.headerTwoImages[j].publicId})
            }
          }
          if (typeof data.headerThreeImages != 'undefined') {
            for (var k=0; k<data.headerThreeImages.length; k++){
              this.headerThreeImages.push({'src': data.headerThreeImages[k].url, 'publicId': data.headerThreeImages[k].publicId})
            }
          }
        })
    },
    toggleDiv(param, el_no) {
      const obj = Object.entries(this.sidebarContentVisibility)
      for (const [key, value] of obj) {
        if (key == param) {
          this.sidebarContentVisibility[key] = true
          localStorage.setItem('active_sidebar_el', JSON.stringify({param, el_no}))
        } else {
          this.sidebarContentVisibility[key] = false
        }
      }
      this.active_el = el_no
    },
    openPaymentPasswordModal () {
      if (this.sidebarContentVisibility.isPayment) {
        return
      }
      this.confPassword = ''
      this.passMisMatch = false
      this.checkPasswordLoading = false
      this.showPaymentPasswordModal = true
    },
    closePaymentPasswordModal () {
      this.showPaymentPasswordModal = false
      this.confPassword = ''
      this.passMisMatch = false
      this.checkPasswordLoading = false
    },
    confirmPasswordBeforePayment () {
      this.checkPasswordLoading = true
      this.checkPassword()
    },
    checkPassword () {
      let url = process.env.VUE_APP_API_URL+'/api/user/validateAdminPassword'

      axios
        .post(url, {'password': this.confPassword},
        {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          }
        })
        .then(()=> {
          this.passMisMatch = false
          this.closePaymentPasswordModal()
          this.toggleDiv('isPayment', 5)
        })
        .catch(()=>{
          this.passMisMatch = true
          this.checkPasswordLoading = false
        })
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.content_sidebar{background-color: #ffbfa4 !important; padding-top: 3rem; height: 93vh;}
.content_sidebar ul{padding-left: 1rem;}
.content_sidebar ul li{
  font-size: 1.2rem;
  background-color: transparent;
  border: 0px solid transparent;
  padding: 0 1.25rem;
  margin: .25rem 0;
  cursor: pointer;
}
.content_sidebar ul li.activeElement{font-weight: bold;}

.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}
.modal-vue .modal-title {
  padding: 10px;
  background-color: #FFEDE3;
  border-radius: 10px 10px 0 0;
  top: 10%;
  left: 35%;
}
.modal-vue .modal-own {
  position: fixed;
  width: 500px;
  z-index: 9999;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  top: 15%;
  left: 35%;
}
.modal-vue .close{
  position: absolute;
  top: 10px;
  right: 10px;
}
.submitBtn{
  background-color: #fe750f;
  color: #fff;
  border: unset;
}
</style>
